import {Link} from 'react-router-dom';

import _ from 'utils/i18n';
import {buildURL} from 'utils/url';

const Title = _('FAQ');
const URL = buildURL('faq');

const FAQItem = () => (
    <li className="language-entry available">
        <Link className="label" to={URL}>
            {Title}
        </Link>
    </li>
);

export default FAQItem;
